import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpTV'

export const boostList = (params = '') => Http.get(`/admin/boosts${serialize(params)}`)
export const boostShow = (id) => Http.get(`/admin/boosts/${id}`)
export const boostUpdate = (params) => Http.put(`/admin/boosts/${params.id}`, params)
export const boostDestroy = (id) => Http.delete(`/admin/boosts/${id}`)
